export class NotaFiscal {
  idNota: number;
  nNota: string;
  fornecedor: number;
  data: Date;
  modelo: string;
  serie: string;
  numeroNota: string;
  totalNota: number;
  obs: string;
  chave: string;
  nnotaf: string;
  xml: string;
  nome: string;
  cpfCnpj: string;
  mostrarNaOcorrencia: boolean;
  fatura: boolean;
}